"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _InputHandlers = require("customer-data-ui-utilities/input/InputHandlers");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _KeyCodes = require("UIComponents/constants/KeyCodes");

var _RichTextEditorSlideoutDrawer = _interopRequireDefault(require("./RichTextEditorSlideoutDrawer"));

var propTypes = {
  ControlsAreaComponent: _react.PropTypes.func,
  cancelLabel: _react.PropTypes.node.isRequired,
  children: _react.PropTypes.array,
  controlSize: _react.PropTypes.oneOf(['default', 'small', 'extra-small']),
  controlsAreaComponentProps: _react.PropTypes.object,
  controlsButtonsClassName: _react.PropTypes.string,
  controlsClassName: _react.PropTypes.string,
  insetUseClassName: _react.PropTypes.string,
  onCancel: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  onSecondarySave: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  overrideDrawStyle: _react.PropTypes.bool,
  saveDisabled: _react.PropTypes.bool,
  saveLabel: _react.PropTypes.node.isRequired,
  saveOnEnter: _react.PropTypes.bool,
  saveTooltip: _react.PropTypes.shape({
    headingText: _react.PropTypes.string,
    onClose: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.string,
    title: _react.PropTypes.string,
    use: _react.PropTypes.string,
    disabled: _react.PropTypes.bool
  }),
  secondarySaveButtonContent: _react.PropTypes.func,
  showCancel: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(['inset', 'flush']),
  useTertiaryButtons: _react.PropTypes.bool,
  wrapperClassName: _react.PropTypes.string,
  useStickyControls: _react.PropTypes.bool
};

var GENERIC_SAVE_LABEL = _react.default.createElement(_FormattedMessage.default, {
  message: "customerDataRte.actions.save"
});

var GENERIC_CANCEL_LABEL = _react.default.createElement(_FormattedMessage.default, {
  message: "customerDataRte.actions.cancel"
});

var defaultProps = {
  cancelLabel: GENERIC_CANCEL_LABEL,
  className: 'm-top-0',
  controlSize: 'extra-small',
  insetUseClassName: 'p-x-5',
  open: false,
  saveDisabled: false,
  saveLabel: GENERIC_SAVE_LABEL,
  saveOnEnter: true,
  saveTooltip: {
    open: false
  },
  showControlsBorder: false,
  use: 'inset',
  showCancel: true
};

var RichTextEditorControls =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RichTextEditorControls, _PureComponent);

  function RichTextEditorControls() {
    var _this;

    (0, _classCallCheck2.default)(this, RichTextEditorControls);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditorControls).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(RichTextEditorControls, [{
    key: "handleEnter",
    value: function handleEnter() {
      var _this$props = this.props,
          saveOnEnter = _this$props.saveOnEnter,
          onSave = _this$props.onSave;

      if (saveOnEnter) {
        onSave();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ControlsAreaComponent = _this$props2.ControlsAreaComponent,
          cancelLabel = _this$props2.cancelLabel,
          controlSize = _this$props2.controlSize,
          controlsAreaComponentProps = _this$props2.controlsAreaComponentProps,
          controlsButtonsClassName = _this$props2.controlsButtonsClassName,
          controlsClassName = _this$props2.controlsClassName,
          insetUseClassName = _this$props2.insetUseClassName,
          onCancel = _this$props2.onCancel,
          onSave = _this$props2.onSave,
          onSecondarySave = _this$props2.onSecondarySave,
          open = _this$props2.open,
          overrideDrawStyle = _this$props2.overrideDrawStyle,
          saveDisabled = _this$props2.saveDisabled,
          saveLabel = _this$props2.saveLabel,
          saveTooltip = _this$props2.saveTooltip,
          secondarySaveButtonContent = _this$props2.secondarySaveButtonContent,
          showCancel = _this$props2.showCancel,
          use = _this$props2.use,
          useStickyControls = _this$props2.useStickyControls,
          useTertiaryButtons = _this$props2.useTertiaryButtons,
          wrapperClassName = _this$props2.wrapperClassName;
      return _react.default.createElement("div", {
        "data-selenium-test": "rich-text-editor",
        className: wrapperClassName,
        onKeyUp: this.partial(_InputHandlers.onKeyAction, [{
          keys: _KeyCodes.ENTER,
          cb: this.handleEnter
        }])
      }, this.props.children, _react.default.createElement(_RichTextEditorSlideoutDrawer.default, {
        ControlsAreaComponent: ControlsAreaComponent,
        cancelLabel: cancelLabel,
        controlSize: controlSize,
        controlsAreaComponentProps: controlsAreaComponentProps,
        controlsButtonsClassName: controlsButtonsClassName,
        controlsClassName: controlsClassName,
        insetUseClassName: insetUseClassName,
        onCancel: onCancel,
        onSave: onSave,
        onSecondarySave: onSecondarySave,
        open: open,
        overrideDrawStyle: overrideDrawStyle,
        saveDisabled: saveDisabled,
        saveLabel: saveLabel,
        saveTooltip: saveTooltip,
        secondarySaveButtonContent: secondarySaveButtonContent,
        showCancel: showCancel,
        use: use,
        useStickyControls: useStickyControls,
        useTertiaryButtons: useTertiaryButtons
      }));
    }
  }]);
  return RichTextEditorControls;
}(_PureComponent2.default);

RichTextEditorControls.propTypes = propTypes;
RichTextEditorControls.defaultProps = defaultProps;
var _default = RichTextEditorControls;
exports.default = _default;
module.exports = exports.default;